/**
 * Swaps/reorders a contiguous group of Shopify sections on mobile via [data-mobile-order].
 * A comment marker anchors the group so it never jumps to the end of #MainContent.
 */
(function () {
  if (window.__sectionMobileOrderInit) return;
  window.__sectionMobileOrderInit = true;

  var MQ = window.matchMedia('(max-width: 749px)');
  var marker = null;
  var sourceIds = null;

  function getItems() {
    var seen = [];
    return Array.prototype.slice
      .call(document.querySelectorAll('[data-mobile-order]'))
      .map(function (node) {
        return {
          node: node,
          sectionEl: node.closest('.shopify-section') || node,
          order: parseInt(node.getAttribute('data-mobile-order'), 10) || 0,
        };
      })
      .filter(function (item) {
        if (!item.sectionEl || seen.indexOf(item.sectionEl) !== -1) return false;
        seen.push(item.sectionEl);
        return true;
      });
  }

  function byDomOrder(a, b) {
    if (a.sectionEl === b.sectionEl) return 0;
    var pos = a.sectionEl.compareDocumentPosition(b.sectionEl);
    return pos & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
  }

  function ensureMarker(items) {
    if (marker && marker.parentNode) return;

    var domItems = items.slice().sort(byDomOrder);
    var first = domItems[0].sectionEl;
    marker = document.createComment('section-mobile-order-anchor');
    first.parentNode.insertBefore(marker, first);

    sourceIds = domItems.map(function (item) {
      return item.sectionEl.id;
    });
  }

  function sortForViewport(items) {
    if (!MQ.matches) {
      return items.slice().sort(function (a, b) {
        var ai = sourceIds.indexOf(a.sectionEl.id);
        var bi = sourceIds.indexOf(b.sectionEl.id);
        if (ai === -1) ai = 999;
        if (bi === -1) bi = 999;
        return ai - bi;
      });
    }

    return items.slice().sort(function (a, b) {
      if (a.order !== b.order) return a.order - b.order;
      return sourceIds.indexOf(a.sectionEl.id) - sourceIds.indexOf(b.sectionEl.id);
    });
  }

  function placeAfterMarker(items) {
    if (!marker || !marker.parentNode) return;
    var parent = marker.parentNode;
    var ref = marker;
    items.forEach(function (item) {
      parent.insertBefore(item.sectionEl, ref.nextSibling);
      ref = item.sectionEl;
    });
  }

  function apply() {
    var items = getItems();
    if (items.length < 2) return;

    ensureMarker(items);
    placeAfterMarker(sortForViewport(items));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }

  if (typeof MQ.addEventListener === 'function') {
    MQ.addEventListener('change', apply);
  } else if (typeof MQ.addListener === 'function') {
    MQ.addListener(apply);
  }

  document.addEventListener('shopify:section:load', function () {
    marker = null;
    sourceIds = null;
    apply();
  });
  document.addEventListener('shopify:section:reorder', function () {
    marker = null;
    sourceIds = null;
    apply();
  });
})();
